import { Mentor } from "../models/mentor.model";

export const MENTORS: Mentor[] = [
  {
    'fileName': 'mentor-m-01.png',
    'name': 'Kevin',
    'position': 'Vice President',
    'company': 'JPMorgan Chase & Co.',
    'desc': '毕业后曾就职于美国银行(Bank of America)担任Vice President一职,现担任摩根大通银行(JPMorgan Chase & Co) Vice President,主要负责公司风险管控和量化模型研究'
  },
  {
    'fileName': 'mentor-m-02.png',
    'name': 'Alex',
    'position': 'Associate ',
    'company': 'McKinsey & Company',
    'desc': '毕业后曾就职于凯迪拉克,特斯拉及微软等公司,担任部门资深顾问等职位。现担任麦肯锡公司(McKinsey & Company)MKT部门资深顾问管理人员,参与各大项目的策划与管理。'
  },
  {
    'fileName': 'mentor-m-03.png',
    'name': 'Nee',
    'position': 'Systems Engineer',
    'company': 'Cisco',
    'desc': '毕业后就职于Cisco 2年以上,现担任系统工程师,主要负责公司的系统设计与分析,精通Programming和Python。'
  },
  {
    'fileName': 'mentor-f-01.png',
    'name': 'Jessica',
    'position': 'Assistant Marketing Manager',
    'company': 'L\'Oréal',
    'desc': '就职于欧莱雅公司3年以上,现担任市场部经理,主要负责活动策划,及监督产品检查并给公司提供反馈。'
  },
  {
    'fileName': 'mentor-f-02.png',
    'name': 'Lu',
    'position': 'Financial Advisory Manager',
    'company': 'EY',
    'desc': '曾就职于普华永道,已在安永公司工作4年以上,现担任金融咨询经理,主要负责给重要客户提供投资,税务和保险方面的建议,并参与各大项目的策划与管理。'
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/mentors.ts